<template>
  <div class="results-wrapper" :class="{ dark }">
    <div class="search-results">
      {{ labels.results }} {{ labels.results === 1 ? 'result' : 'results' }}
      {{ labels.searchData && labels.searchData.length ? ` for '${labels.searchData}'` : '' }}
    </div>
    <template v-if="filterLabels.length">
      <div
        v-for="([category, filter], id) in filterLabels"
        :key="id" class="search-label"
        :class="category"
      >
        {{ label(category, filter) }}
        <span v-if="filters[category].type === 'multiple' && filterCounts[category] && (filterCounts[category][filter] || filterCounts[category][filter] === 0)">
          ({{ filterCounts[category][filter] }})
        </span>
        <span v-else-if="filters[category].type !== 'multiple' && (filterCounts[category] || filterCounts[category] === 0)">
          ({{ filterCounts[category] }})
        </span>
        <CloseIcon class="close" :data-event="`${eventPrefix ? `${eventPrefix}_search_label_close.click` : ''}`" @click="closeTag(category, filter)" />
      </div>
    </template>
    <div
      v-if="filterLabels.length"
      class="clear-all"
      :data-event="`${eventPrefix ? `${eventPrefix}_search_labels_clear_all.click` : ''}`"
      @click="clearAll"
    >
      Clear all
    </div>
  </div>
</template>

<script>
import CloseIcon from '../assets/svg/icon-close.svg?vue-component';

export default {
  components: {
    CloseIcon,
  },
  props: {
    dark: Boolean,
    labels: { type: Object, required: false, default: () => ({}) },
    filters: { type: Object, required: true },
    filterCounts: { type: Object, required: false, default: () => ({}) },
    eventPrefix: { type: String, required: false, default: '' },
  },
  computed: {
    filterLabels() {
      const labels = [];
      const filters = this.labels.filtersData;
      // eslint-disable-next-line no-restricted-syntax
      for (const topic in filters) {
        if (filters[topic].length > 0) {
          filters[topic].forEach((el) => {
            if (el.length > 0 && (topic !== 'minutes' || (topic === 'minutes' && el.join(',') !== `${this.filters[topic].values[topic].min},${this.filters[topic].values[topic].max}`))) {
              labels.push([topic, el]);
            }
          });
        }
      }

      return labels;
    },
  },
  methods: {
    closeTag(type, filter) {
      this.$emit('closeLabel', { type, filter });
    },
    clearAll() {
      this.$emit('clearAll');
    },
    label(category, filter) {
      if (this.filters[category].values[filter]) {
        return this.filters[category].values[filter].text;
      }
      if (category === 'minutes') {
        return `${this.filters[category].values[category].value.join('-')}min`;
      }

      return this.filters[category].values[category].value.join('-');
    },
  },
};
</script>

<style lang="scss" scoped>
.results-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  column-gap: var(--spacing-16);
  row-gap: 10px;
  margin: var(--spacing-16) 0 var(--spacing-40) 0;

  .search-results {
    font-weight: 500;
    font-size: 18px;
    line-height: 110%;
    color: var(--main-dark-shade-0);
    flex: 100%;
    margin-bottom: 2px;
  }

  .search-label {
    display: flex;
    align-items: center;
    text-align: center;
    padding: var(--spacing-8) var(--spacing-16);
    gap: var(--spacing-8);
    background: var(--main-light-shade-3);
    border-radius: 100px;
    line-height: 110%;
    text-transform: capitalize;

    > span {
      color: var(--main-dark-light-4);
    }

    &.duration,
    &.minutes,
    &.search {
      text-transform: lowercase;
    }

    &.search {
      text-transform: lowercase;
    }

    .close {
      width: 10px;
      cursor: pointer;
    }
  }

  .clear-all {
    font-weight: 600;
    color: var(--main-dark-shade-4);
    cursor: pointer;
  }

  &.dark {
    .search-label {
      font-size: 14px;
      background: var(--main-dark-light-4);
    }

    .search-results {
      color: var(--main-light);
    }

    .search-label .close path[stroke] {
      stroke: var(--main-light);
    }
  }
}
</style>
